export default __webpack_public_path__ + "static/section_4_details_14-771bc563936ba6570294530b5139193b.png";